module.exports = __webpack_public_path__ + "static/media/2a.890a9631.jpg";